<template>
    <div class="setting-component">

        <!-- [ Menu ] end -->
        <div class="wrap">
            <div class="wrap__tree">
                <!--<div class="nav-tree">-->
                    <!--<el-button @click="openModalAdd('create')" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">Add GL Account Group</el-button>-->
                <!--</div>-->
                <el-card shadow="hover">
                <el-form :model="form" size="mini" ref="form" status-icon :rules="rules"  class="demo-ruleForm">
                    <el-row :gutter="10" :span="24">
                        <el-col :span="4" style="display:flex;">
                            <div v-if="selectedGroupId" style="display:flex; align-items: flex-end; font-size: 13px; color: #606266; line-height: 28px; padding-bottom: 19px;" >
                                <span>{{selectedGroupId}}-</span>
                            </div>
                            <el-form-item :label="$t('settings_accountThink_GLAccounts_number')" prop="number">
                                <!--hello-->
                                <el-input type="number" :placeholder="$t('settings_accountThink_GLAccounts_number')" v-model="form.number"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item :label="$t('settings_accountThink_GLAccounts_name')" prop="name">
                                <el-input :placeholder="$t('settings_accountThink_GLAccounts_name')" v-model="form.name"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item :label="$t('settings_accountThink_GLAccounts_group')" prop="groupId" >
                                <el-select v-model="form.groupId" :placeholder="$t('settings_accountThink_GLAccounts_group')" style="width: 100%;">
                                    <el-option v-for="item in groupList"
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id" @click.native="selectType(item)">
                                        <span style="float: left; color: #8492a6; font-size: 13px">{{ item.groupId }}</span>
                                        <span style="float: right">{{ item.name }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item :label="$t('settings_accountThink_GLAccounts_parent')" prop="parentId" >
                                <el-select v-model="form.parentId" clearable :placeholder="$t('settings_accountThink_GLAccounts_parent')" style="width: 100%;">
                                    <el-option v-for="item in parentList"
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item :label="$t('settings_accountThink_GLAccounts_taxRate')" prop="taxRateId" >
                                <el-select v-model="form.taxRateId" :placeholder="$t('settings_accountThink_GLAccounts_taxRate')" style="width: 100%;">
                                    <el-option v-for="item in taxRateList"
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item :label="$t('settings_accountThink_GLAccounts_openingBalance')" prop="openingBalance">
                                <money v-model="form.openingBalance" v-bind="money"></money>
                                <!--<el-input style="display:flex; justify-content: flex-end;" number type="number" placeholder="Opening Balance" v-model="form.openingBalance"></el-input>-->
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item style="display:flex; flex-direction: row-reverse;">
                        <el-button @click="addItem('form')" class="modal__btn" type="primary" plain size="small">{{$t('settings_accountThink_GLAccounts_addGLAccount')}}</el-button>
                    </el-form-item>
                </el-form>
                </el-card>


                <el-table
                        :data="tableData"
                        style="width: 100%"
                        row-key="myIndex"
                        :empty-text="$t('general_noData')"
                        :tree-props="{children: 'account', hasChildren: 'true'}"
                        :cell-class-name="cellClassName"
                        :row-class-name="tableRowClassName"
                        :header-cell-class-name="headerCellClassName"
                        @cell-click="cellClick"
                        border
                        default-expand-all>
                    <!--<el-table-column-->
                            <!--type="index"-->
                            <!--width="50">-->
                    <!--</el-table-column>-->
                    <el-table-column
                            prop="groupName"
                            :label="$t('settings_accountThink_GLAccounts_group')"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            :label="$t('settings_accountThink_GLAccounts_number')"
                            width="80">
                        <template slot-scope="scope">
                            <div v-if="scope.row.groupName">
                                {{scope.row.groupId}}
                            </div>
                            <div v-if="scope.row.accountName">
                                {{scope.row.code}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            :label="$t('settings_accountThink_GLAccounts_account')">
                        <template slot-scope="scope">
                            <div v-if="scope.row.accountName">
                                {{scope.row.accountName}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="parentGroupName"
                            :label="$t('settings_accountThink_GLAccounts_parent')"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            :label="$t('settings_accountThink_GLAccounts_tax')"
                            width="100">
                        <template slot-scope="scope">
                            <div v-if="scope.row.tax">
                                {{scope.row.tax.name}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            :label="$t('settings_accountThink_GLAccounts_currentBalance')"
                            width="120">
                        <template slot-scope="scope">
                            <div style="display:flex; justify-content: flex-end;" v-if="scope.row.accountName">
                                {{formatPrice(scope.row.openingBalance)}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            :label="$t('settings_accountThink_GLAccounts_operation')"
                            width="120">
                        <template slot-scope="scope">
                            <div v-if="scope.row.accountName">
                            <el-button
                                    size="mini"
                                    type="primary"
                                    plain
                                    icon="el-icon-edit"
                                    @click="handleEdit(scope.$index, scope.row)"></el-button>
                            <el-button
                                    size="mini"
                                    type="danger"
                                    plain
                                    icon="el-icon-delete"
                                    @click="handleDelete(scope.$index, scope.row)"></el-button>
            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!-- Add -->
        <!--<sweet-modal blocking ref="openModal"  class="modal" v-on:close="closeModal">-->
            <!--<h1>Add GL Account Group</h1>-->
            <!--<el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">-->
                <!--<el-form-item prop="groupId">-->
                    <!--<el-input type="number" placeholder="Group ID" v-model="form.groupId"></el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item prop="name">-->
                    <!--<el-input placeholder="Name" v-model="form.name"></el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item>-->
                    <!--<el-select v-model="form.subGroupId" placeholder="Subgroup of" style="width: 100%;">-->
                        <!--<el-option v-for="item in subGroupList"-->
                                   <!--:key="item.id"-->
                                   <!--:label="item.name"-->
                                   <!--:value="item.id">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                <!--</el-form-item>-->
                <!--<el-form-item>-->
                    <!--<el-select v-model="form.classId" placeholder="Class" style="width: 100%;">-->
                        <!--<el-option v-for="item in classList"-->
                                   <!--:key="item.id"-->
                                   <!--:label="item.name"-->
                                   <!--:value="item.id">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                <!--</el-form-item>-->

                <!--<el-form-item>-->
                    <!--<el-button @click="addItem('form')" class="modal__btn" type="primary" plain size="small">Add GL Account Class</el-button>-->
                <!--</el-form-item>-->
            <!--</el-form>-->
        <!--</sweet-modal>-->

        <!-- Edit -->
        <sweet-modal blocking :title="$t('settings_accountThink_GLAccounts_editGLAccountGroup')" ref="openModalEdit"  class="modal" v-on:close="closeModalEdit">
            <el-form :model="formEdit" size="mini" ref="formEdit" status-icon :rules="rules"  class="demo-ruleForm">
                <el-row :gutter="10" :span="24">
                    <el-col :span="4">
                        <el-form-item :label="$t('settings_accountThink_GLAccounts_number')" prop="number">
                            <el-input type="number" :placeholder="$t('settings_accountThink_GLAccounts_number')" v-model="formEdit.number"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('settings_accountThink_GLAccounts_name')" prop="name">
                            <el-input :placeholder="$t('settings_accountThink_GLAccounts_name')" v-model="formEdit.name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('settings_accountThink_GLAccounts_type')" prop="typeId" >
                            <el-select v-model="formEdit.groupId" :placeholder="$t('settings_accountThink_GLAccounts_type')" style="width: 100%;">
                                <el-option v-for="item in groupList"
                                           :key="item.id"
                                           :label="item.name"
                                           :value="item.id"
                                           >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('settings_accountThink_GLAccounts_parent')" prop="parentId" >
                            <el-select v-model="formEdit.parentId" clearable :placeholder="$t('settings_accountThink_GLAccounts_parent')" style="width: 100%;">
                                <el-option v-for="item in parentList"
                                           :key="item.id"
                                           :label="item.name"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('settings_accountThink_GLAccounts_taxRate')" prop="taxRateId" >
                            <el-select v-model="formEdit.taxRateId" :placeholder="$t('settings_accountThink_GLAccounts_taxRate')" style="width: 100%;">
                                <el-option v-for="item in taxRateList"
                                           :key="item.id"
                                           :label="item.name"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('settings_accountThink_GLAccounts_openingBalance')" prop="openingBalance">
                            <el-input type="number" :placeholder="$t('settings_accountThink_GLAccounts_openingBalance')" v-model="formEdit.openingBalance"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item style="display:flex; flex-direction: row-reverse;">
                    <el-button @click="editItem('formEdit')" class="modal__btn" type="primary" plain size="small">{{$t('settings_accountThink_GLAccounts_editGLAccountGroup')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>


    </div>
</template>

<script>
  function addMyIndexToAcc(array, counter){
    counter ++;
    let newArray = [];
    for(let i = 0; i < array.length; i++){
    array[i].accountName = array[i].name;
    array[i].parentGroupName = array[i].parent ? array[i].parent.name : false;
    array[i].myIndex = counter;
      newArray.push(array[i]);
      counter ++
    }
    return [newArray, counter]
  }

  function addMyIndex(array){
    let counter = 1;
    let myArr = [];
    array.forEach(val => {
      val.myIndex = counter;
      val.groupName = val.name;
      if(val.account.length > 0){
        const resp = addMyIndexToAcc(val.account, counter);
        val.account = resp[0];
        counter = resp[1]
      }
      myArr.push(val);
      counter++
    });
    return myArr
  }
  function buildTree(array) {
    let newTree = [];
    let arrayOfGroups = [];

    //FILTER GROUPS AND PUSH THEM ALL INTO ARRAY
    array.forEach(val => {
        val.group.accounts = []
        val.group.groupName = val.group.name
        arrayOfGroups.push(val.group)
    })

    // FILTER GROUPS AND THEIR UNIQUE IDs
    let unique = [...new Set(arrayOfGroups.map(item => item.id))];
      console.log('unique', unique)
    //FIND GROUP AND ADD UNIQUE GROUP TO ARRAY
    unique.forEach(val =>{
        const neFilt = arrayOfGroups.filter(x => x.id === val)
      console.log('neFit', neFilt[0])
      newTree.push(neFilt[0])
    });

    let newArrayOfGroups = []

    newArrayOfGroups = newTree
    console.log('new tree', newTree)
    console.log('newArrayOfGroups', newArrayOfGroups)

    for(let i = 0; i < newTree.length; i++){
       // const found = array.find(account => account.groupId === unique[i])
      const found = array.filter(x => x.groupId === newTree[i].id)
      // newTree[i].accounts = found
      found.forEach(val => {
        val.accountName = val.name
        val.parentGroupName = val.group.name
        delete val.group;
        newTree[i].accounts.push(val)
      })
      console.log('FOUND', found)
    }

    console.log('arrayOfGroups', arrayOfGroups);

    console.log('new tree', newTree)
    const treeWithIndexes = addMyIndex(newTree)
    console.log('treeWithIndexes', treeWithIndexes)
    return treeWithIndexes
  }



  import _ from 'lodash'
  // import Header from '@/components/Header.vue'
  // import Menu from '@/components/Menu.vue'

  let moment = require('moment')
  import axios from 'axios'
  import {Money} from 'v-money'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    name: 'settingGLAccounts',
    components: {
      // Header,
      // Menu,
      SweetModal,
      Money
    },
    data() {
      return {
        money: {
          precision: 2,
          decimal: ',',
          thousands: '.'
        },
        btnText: 'GL Account',
        selectedGroupId: false,
        parentList: [],
        groupList: [],
        taxRateList: [],
        tableData: [],
        accountList:[],
        selectedRowId: '',
        moment:moment,
        // classTypeList: [],
        classList: [],
        subGroupList: [],
        form:{
          groupCode: null,
          number: '',
          name: '',
          groupId: '',
          parentId: '',
          taxRateId: '',
          openingBalance:'0.00'
        },
        formEdit:{
          number: '',
          name: '',
          groupId: '',
          parentId: '',
          taxRateId: '',
          openingBalance:'0.00'
        },
        rules: {
          number: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          groupId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          taxRateId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          // parentId: [
          //   { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          // ],
          openingBalance: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
        rulesEdit: {
          number: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          groupId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          taxRateId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          parentId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          openingBalance: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
        modalDel:false,
        currentRow: null,
      }
    },
    methods: {
      handleCurrentChange(val) {
        this.currentRow = val;
        console.log('---handleCurrentChange', val);
      },
      loadList(){
        this.loadDirectories()
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/glAccount/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            // this.tableData = list
            this.tableData = response.data.list;
            this.accountList = addMyIndex(response.data.list);
            console.log(this.accountList);
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      loadDirectories(){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/glAccount/directories?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.parentList = response.data.parents
            this.groupList = response.data.groups
            this.taxRateList = response.data.taxes
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      selectType(item){
        this.selectedGroupId = item.groupId;
      },
      openModalAdd(operation, index, row){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/glAccount/directories?companyId=${this.$route.query.companyId}&operation=${operation}`)
          .then(response => {
            if(operation === 'create'){
              this.subGroupList = response.data.glAccountsList
              this.classList = response.data.glAccountClassesList
              this.$refs.openModal.open()
            }else if(operation === 'update'){
              this.subGroupList = response.data.glAccountsList
              this.classList = response.data.glAccountClassesList
              this.handleEdit(index, row)
            }
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      // * companyChartOfAccountItems/create
      addItem(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            let data = {
              code: this.selectedGroupId.toString() +  this.form.number.toString(),
              name: this.form.name,
              groupId: this.form.groupId,
              parentId: this.form.parentId || null,
              taxId: this.form.taxRateId,
              openingBalance: Number(this.form.openingBalance).toFixed(2)
            };

            const ifCheck = this.checkCode(this.accountList, this.form.number)
            if (ifCheck){
              return this.openAlert('Unique Number is required', 'Attention')
            }

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/glAccount/create?companyId=${this.$route.query.companyId}`, data)
              .then(response => {
                this.notification("Success", `Add ${this.btnText}`, "success");
                this.selectedGroupId = false;
                this.$refs['form'].resetFields();
                this.loadList()
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      cellClassName({row, column, rowIndex, columnIndex}){
        // console.log("COLUMN", columnIndex)
        // if(columnIndex === 0 || columnIndex === 5){
        //   return 'align-center'
        // }
      },
      tableRowClassName({row, rowIndex}) {
        return 'table-rows'
      },
      headerCellClassName({row, column, rowIndex, columnIndex}){
        // if(columnIndex === 0 || columnIndex === 5){
        //   return 'align-center'
        // }
      },
      cellClick(row, column, event){
        if(column.label !== 'Operations'){
          console.log(row)
        }
      },
      closeModal(){
        this.form.name = ''
        this.$refs['form'].resetFields();
      },
      closeModalEdit(){
        this.formEdit.name = ''
        this.$refs['formEdit'].resetFields();
      },
      // * companyChartOfAccountItems/item
      handleEdit(index, row) {
        this.selectedRowId = row.id
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/glAccount/item?companyId=${this.$route.query.companyId}&id=${row.id}`)
          .then(response => {
            this.$refs.openModalEdit.open()
            this.formEdit.number = response.data.item.code
            this.formEdit.name = response.data.item.name
            this.formEdit.groupId = response.data.item.groupId
            this.formEdit.parentId = response.data.item.parentId
            this.formEdit.taxRateId = response.data.item.taxId
            this.formEdit.openingBalance = response.data.item.openingBalance.toFixed(2)
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      // * companyChartOfAccountItems/update
      editItem(formEdit){
        this.$refs[formEdit].validate((valid) => {
          if (valid) {
            let data = {
              code: this.formEdit.number,
              name: this.formEdit.name,
              groupId: this.formEdit.groupId,
              parentId: this.formEdit.parentId,
              taxId: this.formEdit.taxRateId,
              openingBalance: this.formEdit.openingBalance
            }
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/glAccount/update?companyId=${this.$route.query.companyId}&id=${this.selectedRowId}`, data)
              .then(response => {
                this.notification("Success", `Edit ${this.btnText}`, "success");
                this.$refs.openModalEdit.close()
                this.loadList()
                loader.hide()
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleDelete(index, row) {
        console.log(row.id)
        // this.$refs.confirmation.open()
        this.selectedRowId = row.id
        console.log(row)

        this.$confirm('This will permanently delete the GL Account. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/glAccount/delete?companyId=${this.$route.query.companyId}&id=${this.selectedRowId}`)
            .then(response => {
              // this.$refs.confirmation.close()
              this.loadList()
              this.notification("Success", `Delete ${this.btnText}`, "success");
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      },
      checkCode(data, code){
        for (let i = 0; i < data.length; i++){
          if(data[i].code == Number(code)){
            return true
          }
        }
        return false
      },
      openAlert(message, title) {
        this.$alert(message, title, {
          confirmButtonText: 'OK',
          callback: action => {

          }
        });
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
    .setting-component{
        min-width:810px;
    }
    .sweet-modal-overlay{
        z-index:10;
    }
    /deep/.el-notification .right{
        z-index: 9999999;
    }
    /deep/.v-money{
        height: 28px;
        line-height: 28px;
        -webkit-appearance: none;
        background-color: transparent;
        background-image: none;
        border: none;
        border-bottom: 2px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        outline: 0;
        padding: 0 15px 0 0;
        -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
        transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
        width: 100%;
    }
</style>
